// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1rFCQ","alert":"SettungsInbox_alert__2ZE8P"};